import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    Output,
} from "@angular/core";

import { DisplayMode } from "@hermes/states/grid-filters-state";

@Component({
    selector: "h-grid-display-mode",
    templateUrl: "./grid-display-mode.component.html",
    styleUrls: ["./grid-display-mode.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GridDisplayModeComponent {
    /** current display mode */
    @Input()
    public displayMode: DisplayMode;

    /** emit to parent component to manage logic */
    @Output()
    public changeDisplayMode: EventEmitter<DisplayMode> =
        new EventEmitter<DisplayMode>();

    /**
     * Trigger on change of display mode
     *
     * @argument value: "grid" | "list"
     */
    public handleChange(value: DisplayMode): void {
        this.displayMode = value;
        this.changeDisplayMode.emit(value);
    }
}
